'use strict';

angular
.module('aq.admin')
.controller('AdministrationCtrl', function (UserService) {
    UserService.getUser();
});